// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export default {
  // QueryMetrics
  RetrievedDocumentCount: "retrievedDocumentCount",
  RetrievedDocumentSize: "retrievedDocumentSize",
  OutputDocumentCount: "outputDocumentCount",
  OutputDocumentSize: "outputDocumentSize",
  IndexHitRatio: "indexUtilizationRatio",
  IndexHitDocumentCount: "indexHitDocumentCount",
  TotalQueryExecutionTimeInMs: "totalExecutionTimeInMs",

  // QueryPreparationTimes
  QueryCompileTimeInMs: "queryCompileTimeInMs",
  LogicalPlanBuildTimeInMs: "queryLogicalPlanBuildTimeInMs",
  PhysicalPlanBuildTimeInMs: "queryPhysicalPlanBuildTimeInMs",
  QueryOptimizationTimeInMs: "queryOptimizationTimeInMs",

  // QueryTimes
  IndexLookupTimeInMs: "indexLookupTimeInMs",
  DocumentLoadTimeInMs: "documentLoadTimeInMs",
  VMExecutionTimeInMs: "VMExecutionTimeInMs",
  DocumentWriteTimeInMs: "writeOutputTimeInMs",

  // RuntimeExecutionTimes
  QueryEngineTimes: "queryEngineTimes",
  SystemFunctionExecuteTimeInMs: "systemFunctionExecuteTimeInMs",
  UserDefinedFunctionExecutionTimeInMs: "userFunctionExecuteTimeInMs",

  // QueryMetrics Text
  RetrievedDocumentCountText: "Retrieved Document Count",
  RetrievedDocumentSizeText: "Retrieved Document Size",
  OutputDocumentCountText: "Output Document Count",
  OutputDocumentSizeText: "Output Document Size",
  IndexUtilizationText: "Index Utilization",
  TotalQueryExecutionTimeText: "Total Query Execution Time",

  // QueryPreparationTimes Text
  QueryPreparationTimesText: "Query Preparation Times",
  QueryCompileTimeText: "Query Compilation Time",
  LogicalPlanBuildTimeText: "Logical Plan Build Time",
  PhysicalPlanBuildTimeText: "Physical Plan Build Time",
  QueryOptimizationTimeText: "Query Optimization Time",

  // QueryTimes Text
  QueryEngineTimesText: "Query Engine Times",
  IndexLookupTimeText: "Index Lookup Time",
  DocumentLoadTimeText: "Document Load Time",
  WriteOutputTimeText: "Document Write Time",

  // RuntimeExecutionTimes Text
  RuntimeExecutionTimesText: "Runtime Execution Times",
  TotalExecutionTimeText: "Query Engine Execution Time",
  SystemFunctionExecuteTimeText: "System Function Execution Time",
  UserDefinedFunctionExecutionTimeText: "User-defined Function Execution Time",

  // ClientSideQueryMetrics Text
  ClientSideQueryMetricsText: "Client Side Metrics",
  RetriesText: "Retry Count",
  RequestChargeText: "Request Charge",
  FetchExecutionRangesText: "Partition Execution Timeline",
  SchedulingMetricsText: "Scheduling Metrics"
};
